<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="csat-customize-view" fill-height fluid>
    <page-title title="CSAT Design"></page-title>

    <SingleChoiceQuestion
      v-if="view === routes.SURVEY_CUSTOMIZE_CSAT_QUESTION"
      :color="color"
      :brandName="currentCampaign.brand_name"
      :options="choiceOptions"
      :question="currentQuestion.question"
      :value="-1"
      :animationEnabled="currentCampaign.options.widget_settings.animation_enabled"
    >
      <template v-slot:question>
        <span class="design-label">
            Question: 
          </span>
        <span>{{ questionParts[0] }}</span>
        <input
          class="brand-title-input lgrm-box-input"
          type="text"
          :style="brandTitleInputStyle"
          v-model="brandName"
          disabled
        />
        <span>{{ questionParts[1] }}</span>
      </template>
    </SingleChoiceQuestion>
    <DriversDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_CSAT_DRIVERS"
      :brandTitle="brandName"
      :question="currentQuestion"
      driver-status-label="Enable CSAT driver question for"
      @change="$emit('saveQuestion', currentQuestion)"
    ></DriversDesign>
    <OpenendedDesign
      v-if="view === routes.SURVEY_CUSTOMIZE_CSAT_OPEN_ENDED"
      :color="currentCampaign.primary_color"
      :brandTitle="brandName"
      :question="currentQuestion"
      @change="$emit('saveQuestion', currentQuestion)"
    ></OpenendedDesign>
  </v-container>
</template>

<script>
import routes from '@/route_names'
import constants from '@/constants'
import strings from '@/strings'
import SingleChoiceQuestion from '../../../../../widgets/feedback/src/components/SingleChoiceQuestion.vue'
import DriversDesign from '@/components/survey/DriversDesign.vue'
import OpenendedDesign from '@/components/survey/OpenendedDesign.vue'
export default {
  name: 'CsatView',
  props: {
    view: String,
    campaign: {
      type: Object
    },
    questions: {
      type: Array
    }
  },
  components: { SingleChoiceQuestion, DriversDesign, OpenendedDesign },
  data: function() {
    return {
      color: this.campaign.primary_color,
      brandName: this.campaign.brand_name,
      currentCampaign: this.campaign,
      choiceOptions: strings.SAT.widget_button_labels
    }
  },
  computed: {
    routes: function() {
      return routes
    },
    questionParts: function() {
      if (this.currentQuestion) {
        return this.currentQuestion.question.split('{brand_name}')
      }

      return ['', '']
    },
    brandTitleInputStyle: function() {
      return {
        textAlign: 'center',
        width: this.brandName.length * 10 + 30 + 'px'
      }
    },
    currentQuestion: function() {
      let question = null
      if (!this.questions) return question
      if (this.view === routes.SURVEY_CUSTOMIZE_CSAT_QUESTION) {
        question = this.questions[0]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_CSAT_DRIVERS) {
        question = this.questions[1]
      }
      if (this.view === routes.SURVEY_CUSTOMIZE_CSAT_OPEN_ENDED) {
        question = this.questions[2]
      }
      console.log(question)
      return question
    }
  },
  methods: {
    save(){}
  }
}
</script>

<style lang="stylus">
  
  

</style>
